module.exports = __webpack_public_path__ + "img/40_69_006_540.8b062cc8.jpg";